import {InjectionToken} from '@angular/core';

/** Layout context only; it supplies no identity, tenant or product entitlement. */
export interface LocalDevelopmentLayout {
    readonly title: string;
    readonly navigation: readonly {
        readonly label: string;
        readonly icon: string;
        readonly path: string;
        readonly queryParams: Record<string, string>;
    }[];
}

/** Provide only on an explicitly guarded loopback development route. */
export const LOCAL_DEVELOPMENT_LAYOUT = new InjectionToken<LocalDevelopmentLayout>('LOCAL_DEVELOPMENT_LAYOUT');
